import styled from 'styled-components';
import { Col } from 'antd';

export const CustomColumn = styled(Col)`
	border-radius: 1rem;
`;
